import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { listasDeCodigos } from './listasDeCodigos';

const ROTULOS_DAS_LISTAS: Readonly<Record<string, string>> = {
  codigos: 'Pacote / onde vale',
  itens_inclusos: 'Inclusos',
  cobrar_a_parte: 'Cobrados à parte',
};

/**
 * Código ao lado da descrição do item no contrato (`TP-055`, achado do QA): só com
 * códigos, o revisor não percebe que `80031528` é a diária global, nem que a
 * exclusão de 251 códigos são dietas presas ao pacote errado.
 */
export function ItensCitados({
  escopo,
  efeito,
  descricoes,
}: {
  escopo: unknown;
  efeito: unknown;
  descricoes: Readonly<Record<string, string>>;
}): React.JSX.Element | null {
  const listas = listasDeCodigos(escopo, efeito);
  if (listas.length === 0) return null;

  return (
    <Stack spacing={1} aria-label="Itens citados pela regra">
      {listas.map((lista) => (
        <Box key={lista.campo}>
          <Typography variant="subtitle2">
            {ROTULOS_DAS_LISTAS[lista.campo] ?? lista.campo} ({String(lista.codigos.length)})
          </Typography>
          <Box
            component="ul"
            aria-label={ROTULOS_DAS_LISTAS[lista.campo] ?? lista.campo}
            sx={{ m: 0, pl: 2, maxHeight: 220, overflowY: 'auto', fontSize: '0.8rem' }}
          >
            {lista.codigos.map((codigo) => (
              <li key={codigo}>
                <Typography variant="body2" component="span" sx={{ fontFamily: 'monospace' }}>
                  {codigo}
                </Typography>{' '}
                <Typography
                  variant="body2"
                  component="span"
                  color={descricoes[codigo] === undefined ? 'warning.main' : 'text.secondary'}
                >
                  {descricoes[codigo] ?? 'sem item no contrato'}
                </Typography>
              </li>
            ))}
          </Box>
        </Box>
      ))}
    </Stack>
  );
}
